import React from 'react';
import { Module, SurveyType } from 'shared/services/prisma/types';
import SurveysCard from '../Survey/SurveysCard';

const CX = () => <SurveysCard module={Module.CxSurveys} types={[SurveyType.Cx]} />;

export default CX;
